import React, { useEffect, useState, useCallback } from 'react';
import { LinearProgress } from '@mui/material';
import MerchantDetails from './components/MerchantDetails';
import MerchantModal from '../AddOrUpdate/components/MerchantModal';
import MerchantHubAssignModal from '../../AssignToHub/MerchantHubAssignModal';
import ConfirmationDialog from 'src/shared/components/ConfirmationDialog';
import PndRestApi from 'src/utils/pnd/PndRestApi';
import { showNotification, successNofication } from 'src/shared/components/Notification';
import { ERROR_MESSAGES } from 'src/utils/pnd/PndConstants';

const MerchantDetailsIndex = () => {
  const [reactTableData, setReactTableData] = useState({ tableRowsData: [] });
  const [temp, setTempData] = useState(null);
  const [viewDetailPopup, setViewDetailPopup] = useState(false);
  const [viewAssignPopup, setAssignPopup] = useState(false);
  const [reactTableDataAssigned, setReactTableDataAssigned] = useState([]);
  const [isTitle, setTitle] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isDeleteData, setDeleteData] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isRedirect, setRedirect] = useState(false);

  const getAllMerchantDetails = useCallback(async () => {
    try {
      setLoading(true);
      const response = await PndRestApi.GetAllMerchantDetails();
      if (response && response.status === 200 && response.data?.status === 200) {
        setReactTableData({ tableRowsData: response.data.data || [] });
      } else if (response && response.status === 200 && response.data?.status === 204) {
        setReactTableData({ tableRowsData: [] });
      } else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response?.data?.status || 500}`,
          `Message: ${response?.data?.message || 'Failed to fetch merchants'}`,
        );
      }
    } catch (error) {
      console.error('Error fetching merchant details:', error);
      showNotification(
        "theme-light",
        "ltr",
        "SuccessCode: 500",
        ERROR_MESSAGES.tryCatchError,
      );
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getAllMerchantDetails();
  }, [getAllMerchantDetails]);

  if (isRedirect) {
    window.location.reload();
  }

  const handleAdd = () => {
    setTempData(null);
    setViewDetailPopup(true);
    setTitle("Add Merchant");
  };

  const handleEdit = (merchant) => {
    if (merchant && merchant.merchantId) {
      setTempData(merchant);
      setViewDetailPopup(true);
      setTitle("Edit - Merchant Details");
    }
  };

  const handleDelete = (merchant) => {
    if (merchant && merchant.merchantId) {
      setShowConfirmation(true);
      setDeleteData(merchant);
    }
  };

  const handleConfirmDelete = async () => {
    try {
      setLoading(true);
      const obj = { merchantId: isDeleteData.merchantId };
      const response = await PndRestApi.DeleteMerchant(obj);
      if (response && response.status === 200 && response.data?.status === 200) {
        successNofication(
          "theme-light",
          "ltr",
          "Message: Merchant Details Deleted Successfully"
        );
        getAllMerchantDetails();
      } else {
        showNotification(
          "theme-light",
          "ltr",
          "Message: Operation Failed due to some reason. Please try again"
        );
      }
    } catch (error) {
      showNotification(
        "theme-light",
        "ltr",
        "Message: Operation Failed due to some reason. Please try again"
      );
    } finally {
      setShowConfirmation(false);
      setLoading(false);
    }
  };

  const handleCancelDelete = () => {
    setShowConfirmation(false);
    setDeleteData(null);
  };

  const handleAssignToHub = async () => {
    setAssignPopup(true);
    setTitle("Assign/ UnAssign - Merchant");
    try {
      const response = await PndRestApi.GetAllMerchantHubMappingDetails();
      if (response && response.status === 200 && response.data?.status === 200) {
        setReactTableDataAssigned(response.data.data || []);
      } else {
        console.error('Unexpected response status:', response?.status);
      }
    } catch (error) {
      console.error('Error fetching hub mapping data:', error);
    }
  };

  return (
    <div className="merchant-management-container" style={{ minHeight: '100vh', backgroundColor: '#f8fafc' }}>
      {loading && (
        <LinearProgress
          color="primary"
          sx={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999 }}
        />
      )}

      <MerchantDetails
        reactTableData={reactTableData}
        onAdd={handleAdd}
        onEdit={handleEdit}
        onDelete={handleDelete}
        onAssignHub={handleAssignToHub}
        onRefresh={getAllMerchantDetails}
      />

      {viewDetailPopup && (
        <MerchantModal
          modalShow={viewDetailPopup}
          setModalShow={setViewDetailPopup}
          dataInfo={temp}
          isTitle={isTitle}
        />
      )}

      {viewAssignPopup && (
        <MerchantHubAssignModal
          setRedirect={setRedirect}
          modalShow={viewAssignPopup}
          setModalShow={setAssignPopup}
          isTitle={isTitle}
          reactTableData={reactTableDataAssigned}
        />
      )}

      {showConfirmation && (
        <ConfirmationDialog
          open={showConfirmation}
          onClose={handleCancelDelete}
          onConfirm={handleConfirmDelete}
          title="Confirmation"
          message="Are you sure you want to permanently delete the Merchant?"
        />
      )}
    </div>
  );
};

export default MerchantDetailsIndex;